const handleScroll = (id: string, milliseconds = 500) => {
	const element = document.getElementById(id);
	if (!element) {
		return;
	}
	setTimeout(() => {
		const headerOffset = 170;
		const elementPosition = element.getBoundingClientRect().top;
		const offsetPosition = elementPosition + window.scrollY - headerOffset;

		window.scrollTo({
			top: offsetPosition,
			behavior: "smooth",
		});
	}, milliseconds);
};

export default handleScroll;
